import FrozenLinesIndicator from './FrozenLinesIndicator';
import useFrozenLines, { MoveableFrozenLineProps } from './useFrozenLines';
import './freezeLines.scss';
import { SelectedLineType } from '../../../types';
import { getColumnRootX } from '../../../helpers/gridBoundariesHelpers';

const MoveableFrozenLines: React.FC<MoveableFrozenLineProps> = (props) => {
  const {
    expectedIndex,
    linePosX,
    linePosY,
    freezeBarHandleSize,
    selectedLine,
    left,
    top,
    startMouseDown,
  } = useFrozenLines(props);

  // #region views
  const lineView = (
    x: number,
    y: number,
    width: number,
    height: number,
    lineType: SelectedLineType,
    unFrozen = false
  ) => (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
        background: props.stroke,
        position: 'absolute',
        cursor: 'grab',
        opacity: unFrozen ? 0 : 1,
        zIndex: 2,
        // pointerEvents: unFrozen ? 'none' : 'all',
      }}
      className={unFrozen ? 'hidden-frozen-line' : ''}
      // id={`${lineType}-frozen-line`}
      onMouseDown={(e) => startMouseDown(e, lineType)}
    />
  );

  const unFreezedRowIndicator = () =>
    !props.freezedRows.frozen &&
    lineView(
      // 0,
      getColumnRootX(props.x, props.width, props.rowHeaderWidth, props.isRtl),
      // getColumnRootX(props.x, props.width, props.rowHeaderWidth, props.isRtl),
      top,
      props.rowHeaderWidth,
      freezeBarHandleSize,
      'row',
      selectedLine === 'row'
    );

  const unFreezedColumnIndicator = () =>
    !props.freezedCols.frozen &&
    lineView(
      left,
      props.y, // + props.groupBarHeight,
      freezeBarHandleSize,
      props.colHeaderHeight,
      'column',
      selectedLine === 'column'
    );
  const fixedColumnLine = () =>
    lineView(
      left,
      props.y, // + props.groupBarHeight,
      freezeBarHandleSize,
      props.height,
      'column',
      !props.freezedCols.frozen
    );
  const fixedRowLine = () =>
    lineView(
      props.x,
      top,
      props.width,
      freezeBarHandleSize,
      'row',
      !props.freezedRows.frozen
    );
  // #endregion

  return (
    <>
      {fixedColumnLine()}
      {fixedRowLine()}

      {unFreezedRowIndicator()}
      {unFreezedColumnIndicator()}

      <FrozenLinesIndicator
        {...props}
        linePosX={linePosX}
        linePosY={linePosY}
        expectedIndex={expectedIndex}
        selectedLine={selectedLine}
      />
    </>
  );
};

export default MoveableFrozenLines;
